// extracted by mini-css-extract-plugin
export default {"container":"E4JX9h"};